import React, { Fragment } from 'react';
import { Icons, SVG } from '../../../components/atoms/SVG';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type CheckListViewOnlyItem = { question: string, checked: boolean };
export type CheckListViewOnly = { checkList: CheckListViewOnlyItem[] };

export function CheckListViewOnly({ checkList }: CheckListViewOnly) {
  const { t } = useSonTranslation('TicketBooking');

  return (
    <dl className="ticket-booking__check-list font-regular-15-19">
      {checkList.map(item => (
        <Fragment key={item.question}>
          <dt>{item.checked
            ? <>
                <span className="ticket-booking__check-mark">
                  <SVG svgSpriteId={Icons.ACCEPT_CHECK} />
                </span>
                <span className="invisible">{t('default.checkListItemFullFilled')}</span>
              </>
            : <span className="invisible">{t('default.checkListItemNotFullFilled')}</span>}
          </dt>
          <dd>{item.question}</dd>
        </Fragment>
      ))}
    </dl>
  );
}
